module.exports = __webpack_public_path__ + "static/media/Clock.beee70b6.svg";